export const mapDefaultLinksToLinks = (links) => {
  let defaultLinks = [{
      displayName: 'Facebook URL',
      icon: 'https://mobile360-assets.s3.us-east-2.amazonaws.com/facebook.png', //default link icon
      url: '',
    },
    {
      displayName: 'Instagram URL',
      icon: 'https://mobile360-assets.s3.us-east-2.amazonaws.com/instagram.png', //default link icon
      url: '',
    },
    {
      displayName: 'Twitter URL',
      icon: 'https://mobile360-assets.s3.us-east-2.amazonaws.com/twitter.png', //default link icon
      url: '',
    },
    {
      displayName: 'Yelp URL',
      icon: 'https://mobile360-assets.s3.us-east-2.amazonaws.com/yelp.png', //default link icon
      url: '',
    },
    {
      displayName: 'Snapchat URL',
      icon: 'https://mobile360-assets.s3.us-east-2.amazonaws.com/snapchat.png', //default link icon
      url: '',
    },
  ];


  defaultLinks.forEach(link => {
    // patch missing links if links doesn't exist
    if (!links.find(l => l.icon === link.icon)) {
      links.push(link);
    }
  });

  return links;
};